import React from 'react';

type GlobeIconProps = {
  fillColor?: string;
  className?: string;
  additionalAriaId?: string;
};

export function GlobeIcon({
  additionalAriaId,
  fillColor = '#5F6369',
  className = '',
}: GlobeIconProps) {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-labelledby={`globeIcon${additionalAriaId}`}
    >
      <title id={`globeIcon${additionalAriaId}`}>Globe Icon</title>
      <path
        d="M7 0C3.13993 -3e-06 -4.99999e-06 3.13992 0 7C5.00001e-06 10.8601 3.13994 14 7 14C10.8601 14 14 10.8601 14 7C14 3.13992 10.8601 -3.5e-06 7 0ZM7 1C7.16954 1 7.36542 1.08582 7.60352 1.34766C7.84162 1.60949 8.08987 2.03562 8.30078 2.58398C8.50689 3.11987 8.67817 3.77163 8.79981 4.5H5.2002C5.32183 3.77163 5.49311 3.11987 5.69922 2.58398C5.91013 2.03562 6.15839 1.60949 6.39649 1.34766C6.63458 1.08582 6.83047 1 7 1ZM5.22852 1.26563C5.05669 1.55075 4.90241 1.86897 4.76563 2.22461C4.51344 2.8803 4.31678 3.65155 4.18555 4.5H1.54883C2.25471 2.95983 3.58801 1.7701 5.22852 1.26563ZM8.77051 1.26563C10.4114 1.76994 11.7452 2.95955 12.4512 4.5H9.81348C9.68225 3.65156 9.48656 2.88029 9.23438 2.22461C9.09754 1.86883 8.94242 1.55084 8.77051 1.26563ZM1.19532 5.5H4.06641C4.02406 5.9836 4 6.48391 4 7C4 7.51575 4.0241 8.0166 4.06641 8.5H1.19532C1.07207 8.02003 1 7.51902 1 7C1 6.48081 1.072 5.98011 1.19532 5.5ZM5.07715 5.5H8.92285C8.9688 5.98244 9 6.4795 9 7C9 7.52014 8.96875 8.01773 8.92285 8.5H5.07715C5.03125 8.01773 5 7.52014 5 7C5 6.4795 5.0312 5.98244 5.07715 5.5ZM9.9336 5.5H12.8037C12.9271 5.98014 13 6.48077 13 7C13 7.51907 12.927 8.02 12.8037 8.5H9.9336C9.9759 8.0166 10 7.51575 10 7C10 6.48391 9.97595 5.9836 9.9336 5.5ZM1.54883 9.5H4.18555C4.31678 10.3491 4.51335 11.1204 4.76563 11.7764C4.90223 12.1315 5.056 12.4505 5.22754 12.7354C3.58736 12.2307 2.25455 11.04 1.54883 9.5ZM5.2002 9.5H8.79981C8.67816 10.229 8.50699 10.8809 8.30078 11.417C8.08987 11.9654 7.84162 12.3915 7.60352 12.6533C7.36542 12.9152 7.16954 13 7 13C6.83047 13 6.63458 12.9152 6.39649 12.6533C6.15839 12.3915 5.91013 11.9654 5.69922 11.417C5.49302 10.8809 5.32184 10.229 5.2002 9.5ZM9.81348 9.5H12.4512C11.7453 11.0403 10.4121 12.2309 8.77149 12.7354C8.94311 12.4504 9.09772 12.1317 9.23438 11.7764C9.48666 11.1204 9.68225 10.3491 9.81348 9.5Z"
        fill={fillColor}
      />
    </svg>
  );
}
